import { useTranslation } from "@/lib/i18n";
import ObservationsLayerCard from "@/features/widget-forms/forms/observations-map/observations-layer-card";
import { SortableItem, SortableList } from "@/features/admin/components/sortable-list";
import Icon from "@/components/icon/icon";
import styles from "@/features/widget-forms/forms/weather-model-map/weather-model-map-dialog.module.css";

import { ObservationsAddMapLayerModal } from "./observations-add-map-layer-modal";
import { useObservationsMapForm } from "./use-observations-map-form";

export function ObservationsMapParameterLayersPanel() {
  const { t } = useTranslation();
  const {
    mapLayers,
    selectedMapLayers,
    addMapLayer,
    removeMapLayer,
    reorderMapLayers,
    renameMapLayer,
    updateMapLayerEnabledByDefault,
  } = useObservationsMapForm();

  return (
    <div className={styles.settingsPanel}>
      <div className={styles.sectionHeader}>
        <ObservationsAddMapLayerModal
          mapLayers={mapLayers ?? []}
          selectedMapLayerIds={selectedMapLayers.map((it) => it.parameter_map_layer_id)}
          onAddMapLayer={addMapLayer}
        />
      </div>
      <div className={styles.settingsPanelCards}>
        {selectedMapLayers.length > 0 ? (
          <SortableList
            onReorder={reorderMapLayers}
            className={styles.cardGrid}
            groupId="maplayers"
          >
            {selectedMapLayers.map((mapLayer, index) => (
              <SortableItem key={mapLayer.parameter_map_layer_id} index={index}>
                <ObservationsLayerCard
                  config={mapLayer}
                  layerInfo={mapLayers?.find(
                    (m) => m.id === mapLayer.parameter_map_layer_id,
                  )}
                  onRename={(text) => renameMapLayer(mapLayer.parameter_map_layer_id, text)}
                  onEnabledByDefaultChange={(enabled) =>
                    updateMapLayerEnabledByDefault(mapLayer.parameter_map_layer_id, enabled)
                  }
                  onRemove={() => removeMapLayer(mapLayer.parameter_map_layer_id)}
                />
              </SortableItem>
            ))}
          </SortableList>
        ) : (
          <div className={styles.emptyState}>
            <Icon name="map" size={32} />
            <span className={styles.emptyStateText}>
              {t("admin.widgets.fields.observations_map.map_layers.empty")}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
